import { processMessages } from '@/api/messages'
import { checkAccount } from '@/api/account-issue'
import { checkBillingAccount } from '@/api/billing-account-issue'

const successPipeline = (jsConn) => {
  return processMessages(jsConn)
    .then(jsConn => {
      return checkAccount(jsConn)
    })
    .then(jsConn => {
      return checkBillingAccount(jsConn)
    })
    .catch(jsConn => {
      return Promise.reject(jsConn)
    })
}

export { successPipeline }
